// src/pages/index.js

function toCamelCase(str) {
    return str
        .replace(/[-_](.)/g, (_, group1) => group1.toUpperCase()) // handle kebab/snake
        .replace(/^(.)/, (_, group1) => group1.toUpperCase());    // capitalize first
}

function importAll(r) {
    let modules = {};
    r.keys().forEach((key) => {
        // "./dashboard/index.js" → "dashboard"
        const folder = key.split("/")[1];
        const name = toCamelCase(folder);
        modules[name] = r(key).default;
    });
    return modules;
}

export const pagesMap = {...importAll(require.context("./", true, /index\.js$/)),
    User: require("./users/user.js").default,
    Workspace: require("./workspaces/workspace.js").default,
    // Goal: require("./goals/goal/goal.js").default,
};



// export const pagesMap = {
//     Dashboard,
//     Devices,
//     Webhooks,
//     Programs,
//     SingleSend,
//     Contacts,
//     UserAccount,
//     Templates,
//     ChatBots,
//     Settings,
//     Campaigns
// }